var map = {
	"./beaute & sante.png": 8425,
	"./categorie1.png": 3698,
	"./categorie2.png": 5036,
	"./categorie3.png": 7973,
	"./categorie4.png": 9473,
	"./informatique & gaming.png": 9455,
	"./luminaire.png": 815,
	"./meubles.png": 3530,
	"./mode & accessoires.png": 6725,
	"./électroménager & cuisine.png": 903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7118;